/**
 * The type of the action which clears the Toolbox visibility timeout.
 *
 * {
 *     type: CLEAR_TOOLBOX_TIMEOUT
 * }.
 */
export const CLEAR_TOOLBOX_TIMEOUT = 'CLEAR_TOOLBOX_TIMEOUT';

/**
 * The type of (redux) action which updates whether the conference is or is not
 * currently in full screen view.
 *
 * {
 *     type: FULL_SCREEN_CHANGED,
 *     fullScreen: boolean
 * }.
 */
export const FULL_SCREEN_CHANGED = 'FULL_SCREEN_CHANGED';

export const HANGUP_MENU = 'HANGUP_MENU';

/**
 * The type of (redux) action which requests full screen mode be entered or
 * exited.
 *
 * {
 *     type: SET_FULL_SCREEN,
 *     fullScreen: boolean
 * }.
 */
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN';

/**
 * The type of the redux action that toggles whether the overflow menu(s) should be shown as drawers.
 */
export const SET_OVERFLOW_DRAWER = 'SET_OVERFLOW_DRAWER';

/**
 * The type of the (redux) action which shows/hides the OverflowMenu.
 *
 * {
 *     type: SET_OVERFLOW_MENU_VISIBLE,
 *     visible: boolean
 * }.
 */
export const SET_OVERFLOW_MENU_VISIBLE = 'SET_OVERFLOW_MENU_VISIBLE';

export const SET_SHARE_MENU = 'SET_SHARE_MENU';

export const TOGGLE_OVERFLOW_MENU = 'TOGGLE_OVERFLOW_MENU';

/**
 * The type of the action which sets the indicator which determiens whether a
 * fToolbar in the Toolbox is hovered.
 *
 * {
 *     type: SET_TOOLBAR_HOVERED,
 *     hovered: boolean
 * }.
 */
export const SET_TOOLBAR_HOVERED = 'SET_TOOLBAR_HOVERED';

/**
 * The type of the action which sets the permanent visibility of the Toolbox.
 *
 * {
 *     type: SET_TOOLBOX_ALWAYS_VISIBLE,
 *     alwaysVisible: boolean
 * }.
 */
export const SET_TOOLBOX_ALWAYS_VISIBLE = 'SET_TOOLBOX_ALWAYS_VISIBLE';

/**
 * The type of the (redux) action which enables/disables the Toolbox.
 *
 * {
 *     type: SET_TOOLBOX_ENABLED,
 *     enabled: boolean
 * }.
 */
export const SET_TOOLBOX_ENABLED = 'SET_TOOLBOX_ENABLED';

/**
 * The type of the action which sets a new Toolbox visibility timeout and its
 * delay.
 *
 * {
 *     type: SET_TOOLBOX_TIMEOUT,
 *     handler: Function,
 *     timeoutMS: number
 * }.
 */
export const SET_TOOLBOX_TIMEOUT = 'SET_TOOLBOX_TIMEOUT';

/**
 * The type of the action which sets the delay in milliseconds after which
 * the Toolbox visibility is to be changed.
 *
 * {
 *     type: SET_TOOLBOX_TIMEOUT_MS,
 *     timeoutMS: number
 * }.
 */
export const SET_TOOLBOX_TIMEOUT_MS = 'SET_TOOLBOX_TIMEOUT_MS';

/**
 * The type of the (redux) action which shows/hides the Toolbox.
 *
 * {
 *     type: SET_TOOLBOX_VISIBLE,
 *     visible: boolean
 * }.
 */
export const SET_TOOLBOX_VISIBLE = 'SET_TOOLBOX_VISIBLE';

/**
 * The type of the redux action which toggles the toolbox visibility regardless of it's current state.
 *
 * {
 *     type: TOGGLE_TOOLBOX_VISIBLE
 * }.
 */
export const TOGGLE_TOOLBOX_VISIBLE = 'TOGGLE_TOOLBOX_VISIBLE';

/**
 * The type of the redux action which toggles the toolbox for zooming in it's current state.
 *
 * {
 *     type: TOGGLE_TOOLBOX_ZOOMIN
 * }.
 */
export const TOGGLE_TOOLBOX_ZOOMIN = 'TOGGLE_TOOLBOX_ZOOMIN';

/**
 * The type of the redux action which toggles the toolbox for zooming in it's current state.
 *
 * {
 *     type: TOGGLE_TOOLBOX_ZOOMOUT
 * }.
 */
export const TOGGLE_TOOLBOX_ZOOMOUT = 'TOGGLE_TOOLBOX_ZOOMOUT';

/**
 * Set SHare Menu Visbile.
 */
export const SET_SHARE_MENU_VISIBLE = 'SET_SHARE_MENU_VISIBLE';


/**
 * Set White board.
 */
export const SET_WHITEBOARD_INSTANCE = 'SET_WHITEBOARD_INSTANCE';

/**
 * Toggle etherpad.
 */
export const TOGGLE_ETHERPAD = 'TOGGLE_ETHERPAD';

/**
 * Toggle Reactions Button.
 */
export const TOGGLE_REACTIONS_BUTTON = 'TOGGLE_REACTIONS_BUTTON';

/*
 * Action Toggle etherpad
 */
export const ACTION_TOGGLE_ETHERPAD = 'ACTION_TOGGLE_ETHERPAD';

/**
 * Action Toggle white board.
 */
export const ACTION_TOGGLE_WHITE_BOARD = 'ACTION_TOGGLE_WHITE_BOARD';

/**
 * Open white board.
 */
export const OPEN_WHITE_BOARD = 'OPEN_WHITE_BOARD';

/**
 * Open white board finally.
 */
export const OPEN_WHITE_BOARD_FINAL = 'OPEN_WHITE_BOARD_FINAL';


/**
 * Open GIF Modal.
 * {{
*      type: OPEN_CARMODE_MODAL,
*      isCarModeModalOpen: boolean
* }}.
*/
export const OPEN_CARMODE_MODAL = 'OPEN_CARMODE_MODAL';

/**
* Close GIF Modal.
* {{
*      type: CLOSE_CARMODE_MODAL,
*      isCarModeModalOpen: boolean
* }}.
*/
export const CLOSE_CARMODE_MODAL = 'CLOSE_CARMODE_MODAL';


export const CARMODE_MODAL_ID = 'carModeModalView';


/** * The type of the action which sets the indicator which determiens whether labels on toolbar buttons are visible.
 *
 * {
 *     type: SET_LABELS_VISIBLE,
 *     visible: boolean
 * }.
 */
export const SET_LABELS_VISIBLE = 'SET_LABELS_VISIBLE';

/**
 * The type of the action which hides the float toolbox.
 */
export const FLOAT_TOOLBOX_HIDDEN = 'FLOAT_TOOLBOX_HIDDEN';
